<template>
  <div class="home_category_zone pos-r" v-if="goods_list.length">
    <!-- 顶部文案、按钮均由运营在 bgimg 中设计，此处仅整图展示与点击进专区 -->
    <div
      v-if="header_img_src"
      class="zone_header_wrap"
      role="button"
      tabindex="0"
      @click="moreHandle"
    >
      <img
        class="zone_header_img radius-8px"
        :src="header_img_src"
        alt=""
        @error="onHeaderImgError"
      />
    </div>

    <div class="zone_goods f0 scroll_row pos-a l0 r0 b0">
      <div class="scroll_inner">
        <div
          v-for="(g, index) in goods_list"
          :key="'g-' + index"
          class="goods_card"
          @click="goodsHandle(g, index)"
        >
          <div class="goods_img_wrap radius-8px">
            <img
              class="goods_img radius-8px"
              :src="g.img_path || '/static/images/errorimg.jpg'"
              alt=""
              @error="onImgError"
            />
          </div>
          <p class="goods_name ta-c over-ell-1">{{ g.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * categoryZone 单项（ajax.js）：bgimg, sortId, goodsList[{ img_path, name, itemid }]
 * 顶部标题与「进入专区」等均在 bgimg 内，不由前端渲染文字。
 */
export default {
  name: 'homeCategoryZone',
  props: {
    zone: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: -1
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'categoryZone'
    },
  },
  computed: {
    goods_list() {
      const list = this.zone.goodsList || this.zone.goods_list
      return Array.isArray(list) ? list : []
    },
    header_img_src() {
      const bg = this.zone.bgimg
      return typeof bg === 'string' && bg.trim() ? bg.trim() : ''
    }
  },
  methods: {
    moreHandle() {
      const item = {
        ...this.zone,
        ad_target: this.zone.channelid + '_' + this.zone.sortId,
        ad_type: '24',
      }
      this.$emit('banner-click', item, 0, this.flow_area_prefix)
    },
    goodsHandle(g, index) {
      const item = {
        ...g,
        ad_target: g.itemid,
        ad_type: '3',
      }
      this.$emit('banner-click', item, index, this.flow_area_prefix + '-' + (index + 1))
    },
    onImgError(e) {
      const img = e.target
      img.src = '/static/images/errorimg.jpg'
      img.onerror = null
    },
    onHeaderImgError(e) {
      const img = e.target
      img.src = '/static/images/errorimg.jpg'
      img.onerror = null
    }
  }
}
</script>

<style scoped lang="scss">
.home_category_zone {
  margin: 0.1rem 0.11rem 0;
  overflow: hidden;
  box-sizing: border-box;
}

.zone_header_wrap {
  display: block;
  width: 100%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.zone_header_img {
  display: block;
  width: 100%;
  height: auto;
}

.scroll_row {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin: 0 0.1rem;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}

.scroll_inner {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 0.06rem;
  min-width: min-content;
  padding-bottom: 0.02rem;
}

.goods_card {
  flex: 0 0 1.07rem;
  width: 1.07rem;
}

.goods_img_wrap {
  width: 100%;
  height: 1.07rem;
}

.goods_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.goods_name {
  margin: 0.04rem 0;
  font-size: 0.12rem;
  color: #292929;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/homeCategoryZone.vue